export default __webpack_public_path__ + "static/movie-background-24fdb68c9e5d760d781326140718395c.mp4";